import React from 'react';

const activityConfig = {
    LEARNED_PLANT: { icon: '🌿', label: 'Pflanze gelernt', color: 'bg-plantlix-100 dark:bg-plantlix-900/30 text-plantlix-700 dark:text-plantlix-400' },
    DUEL_WON: { icon: '🏆', label: 'Duell gewonnen', color: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400' },
    JOURNAL_WEEK_COMPLETED: { icon: '📖', label: 'Wochenbericht', color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400' },
    ACHIEVEMENT_UNLOCKED: { icon: '🌟', label: 'Achievement', color: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400' },
};

const formatTimeAgo = (timestamp) => {
    const diff = (Date.now() - new Date(timestamp)) / 1000;
    if (diff < 60) return 'gerade eben';
    if (diff < 3600) return `vor ${Math.floor(diff / 60)} Min.`;
    if (diff < 86400) return `vor ${Math.floor(diff / 3600)} Std.`;
    return `vor ${Math.floor(diff / 86400)} Tagen`;
};

const ActivityFeed = ({ activities, loading, compact = false }) => {
    if (loading && activities.length === 0) {
        return (
            <div className={`${compact ? 'p-3' : 'p-6'} space-y-3`}>
                {[1, 2, 3].map(i => (
                    <div key={i} className="flex items-start gap-3 animate-pulse">
                        <div className="w-9 h-9 rounded-full bg-gray-200 dark:bg-white/5 flex-shrink-0" />
                        <div className="flex-1 space-y-2 pt-1">
                            <div className="h-3 bg-gray-200 dark:bg-white/5 rounded-full w-1/3" />
                            <div className="h-2.5 bg-gray-100 dark:bg-white/[0.03] rounded-full w-2/3" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (activities.length === 0) {
        return (
            <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8 px-4' : 'py-16 px-8'}`}>
                <div className="text-3xl mb-2 opacity-50">🌱</div>
                <p className={`font-bold text-gray-500 dark:text-gray-400 ${compact ? 'text-xs' : 'text-sm'}`}>Noch keine Aktivitäten</p>
                {!compact && <p className="text-xs text-gray-400 mt-1">Füge Freunde hinzu, um ihren Fortschritt zu sehen.</p>}
            </div>
        );
    }

    return (
        <div className={`${compact ? 'p-3 space-y-1' : 'p-4 md:p-6 space-y-3'}`}>
            {activities.map((activity) => {
                const cfg = activityConfig[activity.activity_type] || { icon: '👤', color: 'bg-gray-100 dark:bg-white/5 text-gray-600' };
                return (
                    <div key={activity.id} className={`flex items-start gap-3 ${compact ? 'p-2 rounded-xl hover:bg-gray-50 dark:hover:bg-white/5' : 'bg-white dark:bg-[#1e1e1e] p-4 rounded-2xl border border-gray-100 dark:border-white/5 shadow-sm hover:shadow-md transition-shadow'}`}>
                        <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 text-base ${cfg.color}`}>
                            {cfg.icon}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start gap-2">
                                <p className={`font-bold text-gray-900 dark:text-white truncate ${compact ? 'text-xs' : 'text-sm'}`}>
                                    {activity.username}
                                </p>
                                <span className="text-[10px] text-gray-400 flex-shrink-0">{formatTimeAgo(activity.created_at)}</span>
                            </div>
                            <p className={`text-gray-500 dark:text-gray-400 leading-snug ${compact ? 'text-[11px]' : 'text-xs mt-0.5'}`}>
                                {activity.content}
                            </p>
                            {!compact && activity.metadata?.plant_name && (
                                <div className="mt-2 inline-flex items-center gap-2 px-2.5 py-1 bg-gray-50 dark:bg-white/5 rounded-lg border border-gray-100 dark:border-white/5">
                                    <span className="text-xs">🌱</span>
                                    <span className="text-xs font-bold text-gray-700 dark:text-gray-300">
                                        {activity.metadata.german_name || activity.metadata.plant_name}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ActivityFeed;
